import React from 'react'
import Alert from '@mui/material/Alert'

export function EmptyServiceHistory() {
  return <Alert severity="info">No service history</Alert>
}

EmptyServiceHistory.displayName = 'EmptyServiceHistory'
